import { graphql } from "@opensea/graphql"
import { useNotificationFragment } from "./use-notification.fragment"

export const NotificationsTableRowFragment = graphql(
  `
    fragment NotificationsTableRow on Notification {
      ...useNotification
    }
  `,
  [useNotificationFragment],
)
